import { api } from "roboflex-thalamus-request-handler/dist";
import { PermissionModel } from "../models/PermissionModel";
import { sso } from "roboflex-thalamus-sso-lib/dist";

export class PermissionService {
    async getUserPermission(){
        var user = sso.getUsuarioLogado();
        const response = await api.get(`/usuario/${user.id}/funcionalidades`)
        return PermissionModel.fromJson(response.data)   
    }
}